export default __webpack_public_path__ + "static/media/22.e43a707a.jpg";